import { useMemo } from 'react'
import { Button, HStack, VStack } from '@chakra-ui/react'
import NavBar from 'components/NavBar'
import { useSelector } from 'model/hooks'
import { IEntityType, NodeDataT } from 'shared/types'
import { AddIcon } from '@chakra-ui/icons'
import { useNavigate } from 'react-router-dom'
import { dbCreateConference } from 'controllers/conferences'
import _ from 'lodash'
import { NodeModel } from '@minoru/react-dnd-treeview'
import { dbUpdateFileTree } from 'controllers/fileThree'
import FileThree from 'components/FileThree'

const Conferences = () => {
  const navigate = useNavigate()
  const conferences = useSelector(state => state.conferences)
  const fileThreeDBData = useSelector(state => state.fileTree)

  const treeData = useMemo(() => {
    const dbTreeRaw = _.get(fileThreeDBData, IEntityType.CONFERENCES, [])
    const dbTree = _.map(dbTreeRaw, el => {
      if (el.data && el.data.id) {
        const c = _.get(conferences, el.data.id)
        if (c) {
          return { ...el, text: _.get(c, 'title', 'unnamed') }
        } else {
          return null
        }
      } else {
        return el
      }
    })
    const res = _.compact(dbTree)
    const dbTreeDict = _.keyBy(dbTree, 'id')
    _.forEach(conferences, c => {
      if (!_.has(dbTreeDict, c.id)) {
        const n: NodeModel<NodeDataT> = {
          id: c.id,
          parent: 'root',
          text: c.title,
          droppable: false,
          data: {
            id: c.id
          }
        }
        res.push(n)
      }
    })
    return res
  }, [fileThreeDBData, conferences])

  const onChangeFileTree = (treeData: NodeModel<NodeDataT>[]) => {
    dbUpdateFileTree(IEntityType.CONFERENCES, treeData)
  }

  const onCreateClick = async () => {
    const id = await dbCreateConference()
    navigate(`/conferences/${id}`)
  }

  const navBarActions = (
    <HStack>
      <Button colorScheme='teal' leftIcon={<AddIcon />} onClick={onCreateClick}>
        Создать конференцию
      </Button>
    </HStack>
  )

  return (
    <VStack w='full' h='full' spacing={0}>
      <NavBar hideBackButton title='Конференции'>
        {navBarActions}
      </NavBar>
      <VStack align={'center'} w='full' h='full' p={4} overflowY={'auto'}>
        <VStack maxW='4xl' w='full'>
          <FileThree
            treeData={treeData}
            onChange={onChangeFileTree}
            onNodeClick={id => navigate(`/${IEntityType.CONFERENCES}/${id}`)}
          />
        </VStack>
      </VStack>
    </VStack>
  )
}

export default Conferences
